// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"5684a34b","984":"3048a0c2"}[chunkId] + ".chunk.js";
};